"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AnnouncementBanner = void 0;
const react_1 = __importStar(require("react"));
const fa_1 = require("react-icons/fa");
const classnames_1 = __importDefault(require("classnames"));
const INITIAL_INDEX = 0;
function AnnouncementBanner(_a) {
    var { className, children, autoScroll = 5000, onMouseOver, onFocus, onMouseLeave, onBlur } = _a, props = __rest(_a, ["className", "children", "autoScroll", "onMouseOver", "onFocus", "onMouseLeave", "onBlur"]);
    const [showIcons, setShowIcons] = (0, react_1.useState)(false);
    const [index, setIndex] = (0, react_1.useState)(INITIAL_INDEX);
    const childrenArr = (0, react_1.useMemo)(() => {
        if (Array.isArray(children))
            return children;
        return [children];
    }, [children]);
    const handleFocus = () => {
        setShowIcons(true);
    };
    const handleBlur = () => {
        setShowIcons(false);
    };
    const handleIndex = (0, react_1.useCallback)((direction) => {
        if (direction === 'increment') {
            // If new index + 1 (index is 0 based so add 2 for check) is larger than length, wrap around to beginning
            setIndex(index + 2 > childrenArr.length ? INITIAL_INDEX : index + 1);
        }
        if (direction === 'decrement') {
            // If new index - 1 is smaller than 0, wrap around to end
            setIndex(index - 1 < 0 ? (childrenArr === null || childrenArr === void 0 ? void 0 : childrenArr.length) - 1 : index - 1);
        }
    }, [childrenArr.length, index]);
    // Handle Auto scroll
    (0, react_1.useEffect)(() => {
        if (autoScroll) {
            const intervalID = setInterval(() => {
                handleIndex('increment');
            }, autoScroll);
            return () => {
                clearInterval(intervalID);
            };
        }
    }, [autoScroll, index, handleIndex]);
    return (react_1.default.createElement("aside", Object.assign({ className: (0, classnames_1.default)('flex justify-center items-center p-1 bg-yellow w-screen absolute top-0 left-0', className), onMouseOver: () => {
            handleFocus();
            onMouseOver === null || onMouseOver === void 0 ? void 0 : onMouseOver();
        }, onFocus: () => {
            handleFocus();
            onFocus === null || onFocus === void 0 ? void 0 : onFocus();
        }, onMouseLeave: () => {
            handleBlur();
            onMouseLeave === null || onMouseLeave === void 0 ? void 0 : onMouseLeave();
        }, onBlur: () => {
            handleBlur();
            onBlur === null || onBlur === void 0 ? void 0 : onBlur();
        } }, props),
        childrenArr.length > 1 && (react_1.default.createElement("button", { onClick: () => {
                handleIndex('decrement');
            }, className: (0, classnames_1.default)({
                'opacity-0': !showIcons,
                'opacity-100': showIcons,
            }, 'transition duration-200 ease-in-out') },
            react_1.default.createElement(fa_1.FaChevronLeft, null))),
        react_1.default.createElement("div", { className: (0, classnames_1.default)('realtive max-w-screen-lg px-10 flex-auto flex justify-center items-center') }, childrenArr === null || childrenArr === void 0 ? void 0 : childrenArr.map((child, ind) => (react_1.default.createElement("div", { key: ind, className: (0, classnames_1.default)('flex-auto flex justify-center items-center transition duration-300 ease-in-out text-md font-light', {
                absolute: ind !== index,
                'opacity-0': ind !== index,
                'opacity-100': ind === index,
            }) }, child)))),
        childrenArr.length > 1 && (react_1.default.createElement("button", { onClick: () => {
                handleIndex('increment');
            }, className: (0, classnames_1.default)({
                'opacity-0': !showIcons,
                'opacity-100': showIcons,
            }, 'transition duration-200 ease-in-out') },
            react_1.default.createElement(fa_1.FaChevronRight, null)))));
}
exports.AnnouncementBanner = AnnouncementBanner;
